import { Chip, Grid } from "@mui/material";
import EditAction from "../components/edit-action/edit-action";
import DeleteAction from "../components/delete-action/delete-action";
import VerifyAccess from "@/common/components/verify-access/verify-access";
import { requestedMenuAll, requestedFeaturesAll } from "@/from-theme/routes/constants/menuAccess";
import { dateString } from "@/common/components/TableView/helpers/helpers";
import indianNumberFormatComponent from "@/common/helpers/indianNumberFormatComponent";
const {schemeNonEligibleApprovalMasterKey} = requestedMenuAll;
const {updateKey, deleteKey} = requestedFeaturesAll;

export const columns = ({ 
  onRowEdit, onRowDelete, deleteCompetitorMasterStatus, isUpdateDeleteAccess 
}) => ([...[
    
  {
    header: 's-no',
    accessorKey: 'id',
    cell: (value) => {
      const id = value.row.index + 1;
      console.log('columns-id', id)
     return id;
    }
  }, 
  { 
    header: 'product-name',
    accessorKey: 'productName', 
  }, 
  {
    header: 'scheme-type', 
    accessorKey: 'schemeType', 
  }, 
  { 
    header: 'year',
    accessorKey: 'schemeYear', 
  }, 
  { 
    header: 'month',
    accessorKey: 'schemeMonth', 
  }, 
  { 
    header: 'value',
    accessorKey: 'schemeTotal', 
    cell: (value) => { 
      let tv = indianNumberFormatComponent(value.row.original.schemeTotal); 
      return tv;  
    } 
  }, 
  { 
    header: 'no-of-customers',
    accessorKey: 'noOfCustomerCount', 
  }, 
  {
    header: 'created-at',
    hideColumn: true,
    accessorKey: 'createdAt',
    cell: ({ getValue }) => dateString(getValue()) 
  },
  {
    header: 'created-by',
    hideColumn: true,
    accessorKey: 'createdBy'
  },
  {
    header: 'updated-at',
    hideColumn: true,
    accessorKey: 'updatedAt',
    cell: ({ getValue }) => dateString(getValue()) 
  },
  {
    header: 'updated-by',
    hideColumn: true,
    accessorKey: 'updatedBy'
  },
  {
    header: 'status',
    hideColumn: true,
    accessorKey: 'activeStatus',
    cell: (cell) => {
      switch (cell.getValue()) {
        case '0':
          return <Chip color="error" label="In-Active" size="small" variant="light" />;
        case '1':
        default:
          return <Chip color="success" label="Active" size="small" variant="light" />;
      }
    }
  }
], 
...(isUpdateDeleteAccess ? [
  {
    header: 'action',
    id: "edit",
    cell: (props) => (
      <Grid container className="table-icon-actions-2">
        <VerifyAccess requestedMenu={schemeNonEligibleApprovalMasterKey} requestedFeature={updateKey}>
        <Grid item>
        <EditAction
          {...props}
          onRowEdit={onRowEdit}
        />
        </Grid>
        </VerifyAccess>
        {/* <VerifyAccess requestedMenu={ifdCompetitorMasterKey} requestedFeature={deleteKey}>
        <Grid item>
        <DeleteAction
          {...props}
          onRowDelete={onRowDelete} deleteCompetitorMasterStatus={deleteCompetitorMasterStatus}
        />
        </Grid>
        </VerifyAccess> */}
      </Grid>
    ),
    meta: {
      className: 'cell-center'
    }
  }
] : [])]);

export const reportFileName = "Scheme Status Not Eligible Master";
